import styled from "styled-components";

import { CardContainer } from "../../../../../components/card-communications/card-communications-style";

export const SaludPymesQuestionnairesContainer = styled.div`
  .legal {
    font-size: 20px;
    margin: 10px 0 20px;
  }

  .type-options {
    margin-bottom: 20px;
    padding-bottom: 20px;
    border-bottom: 1px solid #d8d8d8;
    
    > div {
      margin-bottom: 10px;
    }
  }

  .questionnaire-buttons-container {
    display: flex;
    margin-top: 80px;

    .button-item {
      margin-right: 70px;
      min-width: 100px;

      &:last-child {
        margin-right: 20px;
        width: 180px;
      }
    }
  }
`;

export const InfoCard = styled(CardContainer)`
  background-color: aliceblue;
  font-size: 16px;
  text-align: justify;
  font-style: italic;
`;

export const QuestionnairesContainer = styled.div`
  .new-hiring-flow-status {
    // para aprovechar el cuestionario completo
    // ocultamos el título para que no se duplique
    display: none;
  }
`;
